import { SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue, RichValue } from '../../../value/types.tsx';
import type { TransformedSingleSelectField, TransformedSingleSelectOption } from '../types.tsx';

const getSingleSelectValue: StringValue<TransformedSingleSelectField> = (field) =>
	String(field.value?.value || '');

export const singleSelectStringValueHandler = {
	[SELECT_CF_TYPE]: getSingleSelectValue,
};

const getSingleSelectRichValue: RichValue<
	TransformedSingleSelectField,
	TransformedSingleSelectOption
> = (field) => field.value || null;

export const singleSelectRichValueHandler = {
	[SELECT_CF_TYPE]: getSingleSelectRichValue,
};
